/* unplugin-vue-components disabled */import { render } from "./ChangeConfirm.vue?vue&type=template&id=2c51529f"
import script from "./ChangeConfirm.vue?vue&type=script&lang=js"
export * from "./ChangeConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__